<template>
  <el-drawer
    v-model="drawer.show"
    custom-class="feedback-drawer"
    :before-close="handleClose"
  >
    <template #header>
      
        <el-tabs v-model="activeName" class="client-tabs" @tab-click="handleMsg">
            <el-tab-pane label="问题反馈" name="one"></el-tab-pane>
            <el-tab-pane label="反馈记录" name="two" value="3"></el-tab-pane>
        </el-tabs>
        <el-badge :value="unReadCount" v-if="unReadCount > 0" class="item badge-num"></el-badge>
    </template>
    


    <template v-if="activeName == 'one'">
        <el-form
        :model="dataForm"
        label-position="top"
        :rules="rules"
        ref="dataForm"
        class="problem"
        >
        <el-form-item label="问题类型" prop="problemType">
            <el-radio-group v-model="dataForm.problemType" class="feedback-radio">
            <el-radio
                v-for="item in options.problemType"
                :key="item.value"
                :label="item.value"
                border
            >{{ item.desc }}</el-radio>
            </el-radio-group>
        </el-form-item>

        <el-form-item prop="content">
            <el-input
            v-model="dataForm.content"
            show-word-limit
            maxlength="200"
            :rows="5"
            type="textarea"
            placeholder="Hi,请输入对产品的建议或反馈吧 ~ 选择匹配的问题类型，有助于问题更快被解决哦。"
            />
        </el-form-item>

        <ab-upload
            :params="uploadParams"
            @update-billsId="updateBillsId"
            ref="fileUpload"
        ></ab-upload>
        </el-form>
    </template>
    
    <template v-if="activeName == 'two'">
        <ul class="feedRecord">
            <li v-for="(obj,idx) in feedback" :key="idx">
              <div class="tel">
                <div class="name">
                    <div><img :src="attachUrl ? attachUrl : require('../../assets/img/user-1.png')" /></div>
                    <h5>{{obj.createByName}}</h5>
                    <i v-if="obj.status == 0 && obj.replyContent"></i>
                </div>
                <div class="connter">
                  <el-popover
                    placement="left-start"
                    :width="300"
                    trigger="hover"
                    :content="obj.content"
                  >
                  <template #reference>
                    {{ obj.problemTypeDesc }}: {{ obj.content }}
                  </template>
                    
                  </el-popover>
                </div>

                <download-preview :files="obj.files010"></download-preview>

                <div class="time">{{ obj.createTime }}</div>
                <div class="connter" v-if="obj.replyContent">
                  <el-popover
                    placement="left-start"
                    :width="300"
                    trigger="hover"
                    :content="obj.replyContent"
                  >
                    <template #reference>
                      回复：{{ obj.replyContent }}
                    </template>
                   </el-popover>
                   
                </div>
                <download-preview :files="obj.files020"></download-preview>
                <div class="time">{{ obj.replyTime }}</div>
                <div @click="handlerRead(obj)" class="read" v-if="obj.status == 0 && obj.replyContent">已读</div>
              </div>
              </li>
            <el-empty description="暂无数据" v-if="!feedback || feedback.length == 0" />
        </ul>
    </template>

    <template #footer>
      <div style="flex: auto">
        <el-button @click="handleClose">取消</el-button>
        <el-button
        v-if="activeName == 'one'"
          type="primary"
          @click="confirmClick"
        >确定</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: {
        show: false
      },
      activeName: 'one',
      options: {},
      dataForm: {
        problemType: '01',
        content: ''
      },
      rules: {
        problemType: [
          { required: true, message: '请选择问题类型', trigger: 'change' }
        ],

        content: [
          { required: true, message: '请输入问题描述', trigger: 'blur' },
          { max: 200, message: '最大长度为200个字符', trigger: 'blur' }
        ]
      },
      uploadParams: {
        coreBillIds: '',
        coreBillNumbers: '',
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'CustomerFeedback',
        billsType: '',
        items: []
      },
      tempBillId: '',
      //获取反馈记录附件信息
      getUploadParams:{
          sourceBillType:"Principal",
          sourceBillId:"3175642408681472",
          items: [
              {
                  title: '营业执照',
                  attachType: '010',
                  required: true
              }
          ],
      },
      attachUrl: '',
      feedback: [],
      unReadCount: 0
    }
  },

  props: {

  },

  mounted() {
    this.getSelectList()
    this.getCustomerFeedbackList()
  },

  methods: {
    getSelectList() {
      this.$get('/crm/customerFeedback/getAllEnum').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        }
      })
    },

    init() {
      this.getAttachUrl()
      this.drawer.show = true
      this.initUpload()
    },

    initUpload() {
      // 初始化上传组件
      this.uploadParams.sourceBillId = ''
      setTimeout(() => {
        let items = [
          {
            title: '问题图片/文件',
            attachType: '010'
          }
        ]
        this.uploadParams.items = items
      }, 500)
    },

    // 附件临时id
    updateBillsId(tempBillId) {
      this.tempBillId = tempBillId
    },

    handleClose() {
      this.dataForm.problemType = '01'
      this.dataForm.content = ''
      this.drawer.show = false
      this.$emit('feedCallbank')
    },
    
    confirmClick() {
        this.$refs.dataForm.validate(valid => {
            if (valid) {
                let params = Object.assign({}, this.dataForm)
                params.tempBillId = this.tempBillId
                this.$post('/crm/client/customerFeedback/add', params).then(({ data }) => {
                    if (data && data.code === 'C0000') {
                    this.$message({
                        type: 'success',
                        message: data.message,
                        offset: 380,
                        grouping: true
                    })
                    this.handleClose()
                    }
                })
            }
        })
    },
    getCustomerFeedbackList () {
      this.$post('/crm/client/customerFeedback/list').then(({data}) => {
        if (data && data.code == 'C0000') {
          this.feedback = data.result.list
          this.feedback.map(e => {
            if (e.billAttachVoList && e.billAttachVoList.length) {
              e.files010 = e.billAttachVoList.filter(e => {return  e.attachType == '010'})
              e.files020 = e.billAttachVoList.filter(e => {return  e.attachType == '020'})
            }
          })
          this.unReadCount = data.extra.unReadCount || 0
        }
      })
    },
    // 获取头像url
    getAttachUrl() {
      this.$post('/p/user/getAttachUrlById').then(({ data }) => {
        if(data.code === 'C0000') {
          this.attachUrl = data.message
        }
      })
    },
    handlerRead (obj) {
      this.$post('/crm/client/customerFeedback/consumeMsgByIds', {ids: [obj.id]}).then(({data}) => {
        if (data && data.code == 'C0000') {
          obj.status = 1
          this.getCustomerFeedbackList()
        }
      })
    },
    handleMsg (val) {
      console.log(this.activeName)
      setTimeout(() => {
        if (this.activeName == 'two') {
          this.getCustomerFeedbackList()
        }
      }, 50)
    }
  }
}
</script>

<style lang="scss">
.feedback-drawer {
    .el-drawer__close-btn{
        margin-top: -11px;
    }
    .el-drawer__header {
        padding-left: 40px;
        padding-right: 40px;
        .el-tabs__header{
            margin-bottom: 0;
        }
    }
    .problem {
      padding: 0 20px;
    }
    .feedback-radio {
        .el-radio {
            height: 36px;
            color: #000;
            border-color: #f0f2f5;
            background: #f0f2f5;
            &:not(:last-child) {
                margin-right: 20px;
            }
            .el-radio__inner {
                display: none;
            }
        }
    }
    .el-drawer__footer {
        text-align: center;
    }
    .feedRecord{
        margin-top: -20px;
        
        li{
            padding: 15px 0;
            border-bottom: 1px solid #f0f2f5;
            position: relative;
            .name{
                display: flex;
                align-items: center;
                div{
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    overflow: hidden;
                }
                img{
                    width: 100%
                }
                h5{
                    font-size: 16px;
                    margin-left: 5px;
                }
                i{
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    margin-left: 8px;
                    border-radius: 50%;
                    background-color: #ff0000;
                }
            }
            .connter{
                margin-top: 7px;
                font-size: 14px;
                span{
                    color: #000;
                    // font-weight: 700;
                }
                width: 100%; /* 设置容器宽度 */
                height: 40px; /* 设置容器高度 */
                display: -webkit-box; /* 使用 box 布局 */
                -webkit-box-orient: vertical; /* 设置元素垂直排列 */
                overflow: hidden; /* 隐藏超出范围的内容 */
            }
            .connter::after {
              content: "";
              display: inline-block;
              width: 1em; /* 加上省略号所占据的空间 */
              margin-left: 3px; /* 省略号与文本之间的距离 */
              background: #fff; /* 隐藏省略号 */
            }
            .time{
                font-size: 14px;
                color: #757575;
            }
            .read{
                display: none;
                position: absolute;
                top: 0;
                right: 0;
                padding: 5px 25px;
                background-color: #000000;
                color: #fff;
                font-size: 14px;
                border-bottom-left-radius: 23px;
                cursor: pointer;
            }
            &:hover .read{
                display: block;
            }
            
        }
        .tel {
          padding: 0 20px;
        }
        li:hover {
          background-color: #f2f7ff;
        }
    }
   .badge-num {
    position: absolute;
    left: 210px;
    top: 10px;
   }
}
</style>
